<template>
  <v-container :class="item.show ? '' : 'py-0'">
      <base-material-dialog
        title='转正申请'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='500'
        persistent
      >
        <template v-slot:content>
          <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row >
                <v-col cols="12" md="12">
                  <v-textarea label="工作业绩与自我评价" filled rounded  rows="10" dense  :rules="required" v-model="form.content"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>

              <v-btn color="primary" rounded :loading="loading" @click='save'>
                提交
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/office/formal.js'

  export default {
    name: 'FormalApply',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          content: ''
        },
        defForm: {
          content: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('提交成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        this.form.content = ''
      }
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
</style>
